// extracted by mini-css-extract-plugin
export var chevron = "_ij-2";
export var dropdownItems = "_ij-0";
export var item = "_ij-1";